import {ALLOW_ADS} from '../shared/constants';

export function allowAds() {
  return {
    type: ALLOW_ADS
  }
}
